export default __webpack_public_path__ + "static/media/light.91ebf8ee.png";